import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonV3Component } from '@gea/digital-ui-lib';
import { AssetTableRow } from '../data-maintenance.model';

@Component({
  selector: 'app-revert-asset-dialog',
  standalone: true,
  imports: [ButtonV3Component],
  templateUrl: './revert-asset-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RevertAssetDialogComponent {
  asset: AssetTableRow;

  constructor(
    private dialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig<AssetTableRow>
  ) {
    this.asset = this.dialogConfig.data!;
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
